



























import { Vue, Component, Prop } from 'vue-property-decorator';
import CustomContainer from '@/components/Globals/CustomContainer.vue';

import sizeSelect from '@/mixins/UGC/sizeSelect';

@Component({
  components: {
    CustomContainer
  },
  mixins: [
    sizeSelect
  ],
})
export default class SizeSelectionContent extends Vue {
  [x: string]: any;

  @Prop({ default: false })
  isLoading!: boolean;

  @Prop({ default: false })
  isDisabled!: boolean;

  get translations() {
    return this.$store.state.translations?.data;
  }

  get sizes() {
    return this.$store.state.utils.audienceSizes;
  }

  get areSizesLoaded() {
    return Object.keys(this.sizes).length > 0;
  }

  mounted() {
    // this.sizeSelected = this.$store.getters['buyPanel/returnSizeBuyPanel'];
    this.$emit('blockCtaPrimaryButton', !this.sizeSelected);
  }
}
